import classNames from 'classnames';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';

import { formatRules } from 'components/so5/Rules/formatRules';

const StyledBodyM = styled(BodyM)`
  .minified & {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

type Props = {
  rule: ReturnType<typeof formatRules>[number];
  minified?: boolean;
};

export const ComposeRule = ({ rule, minified }: Props) => {
  return (
    <Vertical key={rule.id} gap={0.5} className={classNames({ minified })}>
      <Horizontal>
        {rule.icon}
        <StyledBodyM as="p" bold>
          {rule.label}
        </StyledBodyM>
      </Horizontal>
      {!minified && rule.description && (
        <BodyS as="p" color="var(--c-nd-600">
          {rule.description}
        </BodyS>
      )}
      {!minified && rule.error && (
        <BodyM as="p" color="var(--c-yellow-400)">
          {rule.error}
        </BodyM>
      )}
    </Vertical>
  );
};
